import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/xfarmer-wechat-img.png'


_pushScopeId("data-v-648e82ba")
const _hoisted_1 = {
  key: 0,
  class: "cord-c"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, "长按保存图片到微信扫码了解", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "cord",
  src: _imports_0,
  alt: "扫码了解"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
      : _createCommentVNode("", true)
  ]))
}